import { render, staticRenderFns } from "./UgcSalesDataTable.vue?vue&type=template&id=7da3b505&scoped=true&"
import script from "./UgcSalesDataTable.vue?vue&type=script&lang=js&"
export * from "./UgcSalesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UgcSalesDataTable.vue?vue&type=style&index=0&id=7da3b505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3b505",
  null
  
)

export default component.exports